import { render, staticRenderFns } from "./PrioritiesTable.vue?vue&type=template&id=4717f672&"
import script from "./PrioritiesTable.vue?vue&type=script&lang=js&"
export * from "./PrioritiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports